import { Avatar } from "@circleco/compass/components/Avatar";
import { Typography } from "@circleco/compass/components/Typography";
import { Link } from "@tanstack/react-router";

import { t } from "@/i18n-js/instance";
import type { FlaggedContent } from "@/react/types/FlaggedContent";

import { ContentActionText } from "../ContentActionText";
import { getReportHeaderData, getStatusText } from "./reportHeaderHelpers";

const i18nRoot = "settings.moderation.review_flagged_content_modal";

export interface ReportHeaderProps {
  flaggedContent: FlaggedContent;
  onNavigate?: () => void | Promise<unknown>;
}

export const ReportHeader = ({
  flaggedContent,
  onNavigate,
}: ReportHeaderProps) => {
  const { type } = flaggedContent.flagged_contentable ?? {};
  if (!type) return null;

  const {
    avatarUrl,
    chatMessageUrl,
    communityMember,
    communityMemberUrl,
    flaggedContentableId,
    memberName,
    postTitle,
    postUrl,
    recipientName,
    recipientUrl,
    spaceName,
    spaceUrl,
  } = getReportHeaderData(flaggedContent);

  const navLinkProps = {
    onClick: onNavigate,
    className: "font-semibold leading-5 text-dark",
  };

  return (
    <div className="flex items-center gap-3">
      {communityMember && (
        <Link
          to={communityMemberUrl}
          onClick={onNavigate}
          className="flex self-start"
        >
          <Avatar name={memberName ?? ""} src={avatarUrl} size="lg" />
        </Link>
      )}

      <div className="flex flex-col gap-0.5">
        <div className="flex flex-wrap items-center gap-1">
          {communityMember ? (
            <Link to={communityMemberUrl} {...navLinkProps}>
              {memberName}
            </Link>
          ) : (
            <Typography component="span" variant="label-md">
              {t([i18nRoot, "deleted_member"])}
            </Typography>
          )}

          <ContentActionText
            chatMessageUrl={chatMessageUrl}
            flaggedContentableId={flaggedContentableId}
            navLinkProps={navLinkProps}
            postTitle={postTitle}
            postUrl={postUrl}
            recipientName={recipientName}
            recipientUrl={recipientUrl}
            spaceName={spaceName}
            spaceUrl={spaceUrl}
            type={type}
          />
        </div>

        <Typography variant="caption" color="secondary">
          {getStatusText(flaggedContent)}
        </Typography>
      </div>
    </div>
  );
};
